













import { Component, Prop, Vue } from 'vue-property-decorator';
import { SliderMarker } from './types/SliderTypes';

@Component
export default class VueSmartSliderPip extends Vue {
  name = 'VueSmartSliderPip';

  @Prop({ required: true, type: Number }) readonly markerCount!: number;

  @Prop({ required: true, type: Object }) readonly marker!: SliderMarker;

  @Prop({ required: true, type: Number }) readonly width!: number;

  @Prop({ required: true, type: Number }) readonly max!: number;

  get position(): number {
    return this.marker.value / this.max * 100;
  }

  get leftPosition() {
    return this.marker.percentage ?? this.marker.id / (this.markerCount - 1) * 100;
  }
}
